import { helpers } from 'vuelidate/lib/validators';

const laterThanDate = (reference) => {
  if (reference === null || reference === '') {
    return () => false;
  }
  const referenceDateArray = reference.split('/');
  const referenceDay = referenceDateArray[0];
  const referenceMonth = referenceDateArray[1];
  const referenceYear = referenceDateArray[2];
  const referenceDate = new Date(referenceYear, referenceMonth, referenceDay);
  return ((value) => {
    if (!value) return true;

    const valueDateArray = value.split('/');
    const valueDay = valueDateArray[0];
    const valueMonth = valueDateArray[1];
    const valueYear = valueDateArray[2];
    const valueDate = new Date(valueYear, valueMonth, valueDay);
    return !helpers.req(value) || referenceDate < valueDate;
  });
};

export default laterThanDate;
